<template>
    <a-modal
      title="数据表管理"
      width="90%"
      :visible="visible"
      @cancel="hidden"
      class='modelModal'
    >
      <div class="left">
        <a-input class="search" v-model='keyWord' allowClear size='small' placeholder='请输入关键词'></a-input>
        <div class="add" @click='addTable'>
          <a-icon type="plus-circle" />
          新增数据表
        </div>
        <a-menu class='menu' :selectedKeys='selectedKeys'>
          <a-menu-item class='item' v-for="item in filterData" :key="item._id" :id='"x"+item._id' @click='selectMenuItem(item._id)'>
            <div class="name">
              {{item.name}}
            </div>
            <a-popconfirm
              title="删除此数据表?"
              @confirm="deleteTable(item._id)"
              okText="确定"
              cancelText="取消"
              @click.stop
            >
              <a-icon class="icon" type="close" @click.stop/>
            </a-popconfirm>
          </a-menu-item>
        </a-menu>
      </div>
      <div class="right" v-if='activeData'>
        <div class="rightHead">
          <div class="names">
            <div class="name">
              表名：
              <span v-show='!activeData.isTableNameEdit'>{{activeData.table_name}}</span>
              <input type="text" v-model='activeData.table_name' v-show='activeData.isTableNameEdit' @focus='saveprev(activeData.table_name)' @blur="blurEdit(1)" ref='table_name' maxlength='64'>
              <a-icon type="form" v-show='!activeData.isTableNameEdit' @click='nameEdit(1)'/>
            </div>
            <div class="name">
              中文名称：
              <span v-show='!activeData.isNameEdit'>{{activeData.name}}</span>
              <input type="text" v-model='activeData.name' v-show='activeData.isNameEdit'  @focus='saveprev(activeData.name)' @blur="blurEdit(0)" ref='name' maxlength='64'>
              <a-icon type="form" v-show='!activeData.isNameEdit' @click='nameEdit(0)'/>
            </div>
          </div>
          <div class="full"><a-button size="small" @click="fullscreen" >{{ table.full ? '退出全屏' : '全屏编辑' }}</a-button></div>
        </div>

        <div class="fields">
           <a-config-provider :render-empty="table.renderEmpty">
            <a-table :keyboard="false" class="table" :pagination="table.pagination" :columns="table.columns" :dataSource="activeData.fields" :scroll="table.scroll">
                <input :ref="'focus' + $index" slot="field_name" @keyup.enter="addField($index)" slot-scope="field_name, item, $index" type="text"  v-model='item.field_name' @focus="saveprev(field_name)" @blur="blurField(item)" :id="'x' + item._id">
                <input :tab-index="$index + 1" slot="name" slot-scope="name, item, $index" type="text" v-model='item.name' />
                <input slot="desc" slot-scope="desc, item" type="text" v-model='item.desc' maxlength='30'>
                <input slot="limit" slot-scope="limit, item" type="text" v-model='item.limit' maxlength='30'>
                <input slot="format" slot-scope="format, item" type="text" v-model='item.format' maxlength='30'>
              <input slot="verify" slot-scope="verify, item" type="text" v-model='item.verify' maxlength='30'>

              <input slot="foreign_table" slot-scope="foreign_table, item" type="text" v-model='item.foreign_table' maxlength='30'>
              <input slot="foreign_key" slot-scope="foreign_key, item" type="text" v-model='item.foreign_key' maxlength='30'>
              <input slot="foreign_value" slot-scope="foreign_value, item" type="text" v-model='item.foreign_value' maxlength='30'>
                <a-select size="small" slot="type" class='select' slot-scope="type, item" v-model='item.type'>
                  <a-select-option v-for='field in fieldType' :key="field.type" :value="field.type">
                    {{field.name}}
                  </a-select-option>
                </a-select>
              <a-select size="small" class='select' v-model='item.display' slot="display" slot-scope="display, item">
                <a-select-option value=""> {{item.display}}</a-select-option>
                <a-select-option v-for='display in displayType' :key="display.type" :value="display.type">
                  {{display.name}}
                </a-select-option>
              </a-select>
              <a-select size="small" slot="required" slot-scope="required, item" class='select' v-model='item.required'>
                <a-select-option v-for='required in requiredType' :key="required.type" :value="required.type">
                  {{required.name}}
                </a-select-option>
              </a-select>
              <div class="td del" slot="action" slot-scope="_id, item, $index">
                <a-button style="margin-right: 10px" type="primary" size="small" @click="addField($index)">添加</a-button>
                <a-popconfirm
                  title="删除此字段?"
                  @confirm="deleteField($index)"
                  okText="确定"
                  cancelText="取消"
                >
                  <a-button type="danger" size="small">删除</a-button>
                </a-popconfirm>
              </div>
            </a-table>
           </a-config-provider>
         <!-- <div class="table">
           <div class="tr">
             <div class="th" v-for="(item, index) in th" :key="index">
               {{item}}
             </div>
           </div>
           <div class="tds">
             <div class="tr" v-for='(item,index) in activeData.fields' :key="index">
               <div class="td">
                 <input type="text" v-model='item.field_name' @focus='saveprev(item.field_name)' @blur="blurField(item)" :id='"x"+item._id'>
               </div>
               <div class="td">
                 <input type="text" v-model='item.desc' maxlength='30'>
               </div>
               <div class="td">
                 <a-select class='select' v-model='item.type'>
                   <a-select-option v-for='field in fieldType' :key="field.type" :value="field.type">
                     {{field.name}}
                   </a-select-option>
                 </a-select>
               </div>
               <div class="td">
                 <a-select  disabled class='select' v-model='item.display'>
                   <a-select-option value=""> {{item.display}}</a-select-option>
                   <a-select-option v-for='display in displayType' :key="display.type" :value="display.type">
                     {{display.name}}
                   </a-select-option>
                 </a-select>
               </div>
               <div class="td">
                 <a-select disabled class='select' v-model='item.required'>
                   <a-select-option v-for='required in requiredType' :key="required.type" :value="required.type">
                     {{required.name}}
                   </a-select-option>
                 </a-select>
               </div>
             </div>
             <div class="tr puls" @click='addField'>
               <a-icon type="plus" />
             </div>
           </div>
         </div> -->
        </div>
      </div>
      <div class="right" v-else>
        <a-empty class='empty' description='请选择一个数据表'/>
      </div>
      <div class="spin" v-show='spin'>
        <a-spin size="large" />
      </div>
      <template slot="footer">
        <div class="footer">
          <div class="import">
            <a-button type='primary'>
              <a-icon type="download" />
              导入数据表
              <input type="file"  accept="xls/*,xlsx/*" @change='importTable'>
            </a-button>
            <a-button type='link' @click='download'><a-icon type="cloud-download" download="数据表模板.xlsx" />模板下载</a-button>
          </div>
          <div class="footerRight">
<!--             <a-button @click='oneKeyBuild'>
              一键生成
            </a-button>-->
            <a-button @click='hidden'>
              取消
            </a-button>
            <a-button type='primary' @click='sure'>
              确定
            </a-button>
          </div>
        </div>
      </template>
    </a-modal>
</template>

<script>
import table from './table'
export default {
  name: 'modelModal',
  props: {
    model: {
      type: Array
    },
    childrensItem: {
      type: Object
    }
  },
  computed: {
    activeData () {
      return this.findTarget()
    },
    filterData () {
      return this.data.filter(item => item.name && item.name.indexOf(this.keyWord) !== -1)
    }
  },
  data () {
    return {
      table: {
        pagination: false,
        full: false,
        scroll: { x: 1500, y: 330 },
        columns: table.columns,
        renderEmpty: () => {
          return (
            <div class="tr puls" onClick={this.addField}>
              <a-icon type="plus" />
            </div>
          )
        }
      },
      data: [],
      visible: false,
      keyWord: '',
      selectedKeys: [],
      lastName: '',
      th: [
        '字段名',
        '描述',
        '类型',
        '展示类型',
        '是否必填',
        ''
      ],
      rgx: /^[a-z][a-z0-9_]*$/,
      rgx2: /^[a-zA-z][a-zA-z\d_]*$/,
      fieldType: [
        {
          name: '字符串',
          type: 'Text'
        }, {
          name: '数字',
          type: 'Int'
        }, {
          name: '小数',
          type: 'Double'
        }, {
          name: '布尔值',
          type: 'Boolean'
        }, {
          name: '数组',
          type: 'Array'
        }
      ],
      displayType: [
        {
          name: '文本控件',
          type: ''
        },
        {
          name: '图片控件',
          type: 'image'
        }, {
          name: '日期控件',
          type: 'datetime'
        }, {
          name: '视频播放器',
          type: 'video'
        },
        {
          name: '单选框',
          type: 'radio'
        },
        {
          name: '复选框',
          type: 'checkbox'
        },
        {
          name: '多行文本',
          type: 'textarea'
        },
        {
          name: '下拉选择',
          type: 'select'
        },
        {
          name: '隐藏',
          type: 'hide'
        }
      ],
      requiredType: [
        {
          name: '是',
          type: true
        }, {
          name: '否',
          type: false
        }
      ],
      removedTables: [],
      spin: false
    }
  },
  methods: {
    enterFullData () {
      const fixed = { field_name: 1, name: 1 }
      for (let col of this.table.columns) {
        if (fixed[col.dataIndex]) {
          col.fixed = false
        }
      }
      this.table.scroll.y = document.body.getBoundingClientRect().height - 100
    },
    exitFullData () {
      const fixed = { field_name: 1, name: 1 }
      for (let col of this.table.columns) {
        if (fixed[col.dataIndex]) {
          col.fixed = 'left'
        }
      }
      this.table.scroll.y = 330
    },
    fullscreen () {
      const el = document.querySelector('.modelModal')
      if (!this.table.full) {
        el && this.enterFull(el)
      } else {
        el && this.exitFull(el)
      }
      this.table.full = !this.table.full
    },
    exitFull (dom) {
      let rfs = document.exitFullscreen || document.mozCancelFullScreen || document.webkitCancelFullScreen
      rfs && rfs.call(document)
    },
    enterFull (dom) {
      if (!dom) return
      let rfs = dom.requestFullscreen || dom.mozRequestFullScreen || dom.webkitRequestFullScreen
      rfs && rfs.call(dom)
    },
    syncFiled (item) {
      // item.name = item.field_name
    },
    deepClone (target) {
      let result
      // 如果当前需要深拷贝的是一个对象的话
      if (typeof target === 'object') {
        // 如果是一个数组的话
        if (Array.isArray(target)) {
          result = []
          for (let i in target) {
            result.push(this.deepClone(target[i]))
          }
        } else if (target === null) {
          result = null
        } else if (target.constructor === RegExp) {
          result = target
        } else {
          result = {}
          for (let i in target) {
            result[i] = this.deepClone(target[i])
          }
        }
      } else {
        result = target
      }
      // 返回最终结果
      return result
    },
    show (item, level, levelOne) {
      if (this.model && this.model.length) {
        this.data = this.deepClone(this.model)
        // this.data.map(item => {
        //   item.fields.map(items => {
        //     items.name = items.field_name
        //   })
        // })
      } else {
        this.data = []
      }
      if (item === 'model') {
        if (this.data[0]) {
          this.selectedKeys = [this.data[0]._id]
        }
      } else if (item === 'field') {
        this.selectedKeys = [levelOne._id]
      } else if (level === 1) {
        this.selectedKeys = [item._id]
      } else if (level === 2) {
        this.selectedKeys = [levelOne._id]
      }
      this.removedTables = []
      this.visible = true
    },
    hidden () {
      this.data = []
      this.visible = false
    },
    oneKeyBuild () {
      this.$post('/wuwei/api/table/oneKeyBuild', {
        project_id: this.$route.query.project_id,
        function_id: this.childrensItem._id,
        data: JSON.stringify(this.data),
        app_id: this.$route.query.app_id,
        remove: this.removedTables.filter(item => typeof (item) !== 'number')
      }).then(result => {
        if (result.msg) {
          this.$message.warn(result.msg)
        }
        this.$event.$emit('initMVPData')
        // this.$event.$emit('changeModel', result.result)
      })
      this.hidden()
    },
    sure () {
      if (this.activeData) {
        if (!this.activeData.table_name) {
          this.$message.warn('请输入表名称')
          return
        }
        if (this.activeData.fields.find(item => !item.field_name)) {
          this.$message.warn('请填写字段名')
          return
        }
      }
      // this.data.map(item => {
      //   item.fields.map(items => {
      //     delete items._id
      //     items.field_name = items.name
      //     delete items.name
      //   })
      // })
      this.$post('/wuwei/api/table/setting', {
        project_id: this.$route.query.project_id,
        function_id: this.childrensItem._id,
        data: JSON.stringify(this.data),
        app_id: this.$route.query.app_id,
        remove: this.removedTables.filter(item => typeof (item) !== 'number')
      }).then(result => {
        if (result.msg) {
          this.$message.warn(result.msg)
        }
        this.$event.$emit('initMVPData')
        // this.$event.$emit('changeModel', result.result)
      })
      this.hidden()
    },
    addTable () {
      // 新增数据库表
      // this.sendLogger({
      //   action: 'post',
      //   type: 'table',
      //   func_id: this.childrensItem._id
      // })
      if (this.activeData && !this.activeData.table_name) {
        this.$message.warn('请输入表名称')
        return
      }
      if (this.activeData && this.activeData.fields.find(item => !item.field_name)) {
        this.$message.warn('请填写字段名')
        return
      }
      let id = new Date().getTime()
      this.data.unshift({
        _id: id,
        'name': this.findName(this.data, '新增数据表'),
        'table_name': '',
        'desc': '',
        'fields': [],
        'isTableNameEdit': true
      })
      this.selectedKeys = [id]
      this.$nextTick(() => {
        let dom = document.querySelector(`#x${id}`)
        if (dom && dom.scrollIntoView) {
          dom.scrollIntoView()
        }
        if (this.$refs.table_name.focus) {
          this.$refs.table_name.focus()
        }
      })
    },
    findName (arr, str, key = 'name') {
      for (let i = 1; i < arr.length + 2; i++) {
        if (!arr.find(item => item[key] === str + i)) {
          return str + i
        }
      }
    },
    deleteTable (id) {
      // 删除数据库
      // this.sendLogger({
      //   action: 'delete',
      //   type: 'table',
      //   func_id: this.childrensItem._id,
      //   type_id: this.activeData.table_id
      // })
      this.removedTables.push(id)
      let idx = this.data.findIndex(item => item._id === id)
      if (idx !== -1) {
        this.data.splice(idx, 1)
      }
      if (idx > 0) {
        this.selectedKeys = [this.data[idx - 1]._id]
      } else if (this.data && this.data.length) {
        this.selectedKeys = [this.data[0]._id]
      }
    },
    selectMenuItem (id) {
      if (!this.activeData.table_name) {
        this.$message.warn('请输入表名称')
        return
      }
      if (this.activeData.fields.find(item => !item.field_name)) {
        this.$message.warn('请填写字段名')
        return
      }
      this.selectedKeys = [id]
    },
    nameEdit (type) {
      if (!type) {
        this.$set(this.activeData, 'isNameEdit', true)
        this.$nextTick(() => {
          if (this.$refs.name.focus) {
            this.$refs.name.focus()
          }
        })
      } else {
        this.$set(this.activeData, 'isTableNameEdit', true)
        this.$nextTick(() => {
          if (this.$refs.table_name.focus) {
            this.$refs.table_name.focus()
          }
        })
      }
    },
    saveprev (name) {
      this.lastName = name
    },
    blurEdit (type) {
      // 编辑数据库
      // this.sendLogger({
      //   action: 'put',
      //   type: 'table',
      //   func_id: this.childrensItem._id,
      //   type_id: this.activeData.table_id
      // })
      if (!type) {
        if (!this.activeData.name) {
          this.$message.warn('中文名称不能为空')
          this.activeData.name = this.lastName
        }
        if (this.data.find(item => item.name === this.activeData.name && item._id !== this.activeData._id)) {
          this.$message.warn('中文名称重复')
          this.activeData.name = this.lastName
        }
        this.$set(this.activeData, 'isNameEdit', false)
      } else {
        if (!this.activeData.table_name) {
          this.$message.warn('表名不能为空')
          this.activeData.table_name = this.lastName
        } else if (!this.rgx.test(this.activeData.table_name)) {
          this.$message.warn('表名只能使用小写字母/数字/下划线,且必须以小写字母开头')
          this.activeData.table_name = this.lastName
        }
        if (this.data.find(item => item.table_name === this.activeData.table_name && item._id !== this.activeData._id)) {
          this.$message.warn('表名重复')
          this.activeData.table_name = this.lastName
        }
        this.$set(this.activeData, 'isTableNameEdit', false)
      }
    },
    deleteField (index) {
      // 删除数据字段
      // this.sendLogger({
      //   action: 'delete',
      //   type: 'table',
      //   func_id: this.childrensItem._id,
      //   type_id: this.activeData.table_id,
      //   node_id: this.activeData.fields[index]._id
      // })
      this.activeData.fields.splice(index, 1)
    },
    blurField (item) {
      // 编辑数据库字段
      // this.sendLogger({
      //   action: 'put',
      //   type: 'table',
      //   func_id: this.childrensItem._id,
      //   type_id: this.activeData.table_id,
      //   node_id: item._id
      // })
      if (!item.field_name) {
        item.field_name = this.lastName
        this.$message.warn('字段名不能为空')
      } else if (!this.rgx2.test(item.field_name)) {
        this.$message.warn('字段名称只能使用字母/数字/下划线,且必须以字母开头')
        item.field_name = this.lastName
      }
      if (this.activeData.fields.filter(items => items.field_name === item.field_name).length > 1) {
        item.field_name = this.lastName
        this.$message.warn('同一个数据表下字段名不能重复')
      }
    },
    addField (index) {
      // 新增数据库字段
      // this.sendLogger({
      //   action: 'post',
      //   type: 'table',
      //   func_id: this.childrensItem._id,
      //   type_id: this.activeData.table_id,
      //   node_id: this.activeData.fields[index]._id
      // })
      if (this.activeData.fields.find(item => !item.field_name)) {
        this.$message.warn('请填写字段名')
        return
      }
      let id = new Date().getTime()
      const newVar = {
        '_id': id,
        'name': '',
        'desc': '',
        'type': 'Text',
        'display': '',
        'required': 'false',
        'field_name': '',
        focus: true
      }
      if (index === undefined || index === -1) {
        this.activeData.fields.push(newVar)
      } else {
        this.activeData.fields.splice(index + 1, 0, newVar)
      }
      this.$set(this.activeData, 'open', true)
      this.$nextTick(() => {
        const focus = this.$refs[`focus${index + 1}`]
        console.log('focus', focus)
        if (focus) {
          focus.focus()
        }
      })
    },
    importTable (event) {
      const files = event.target.files
      const file = files[0]
      let fd = new FormData()
      fd.append('file', file)
      fd.append('project_id', this.$route.query.project_id)
      fd.append('function_id', this.childrensItem._id)
      fd.append('app_id', this.$route.query.app_id)
      this.spin = true
      this.$post('/api/table/import', fd).then(result => {
        if (result.count === 0 || result.count === '0') {
          this.$message.warn(`导入失败,请检查表名和格式`)
        } else {
          this.$message.success(`新增导入 ${result.count} 张数据表`)
        }
        this.$event.$emit('initMVPData')
      }).catch(res => {
        console.log(res)
        this.spin = false
      })
      event.target.value = ''
    },
    findTarget () {
      let map = {
        false: false,
        '否': false,
        true: true,
        '是': true
      }
      let target = this.data.find(item => item._id === this.selectedKeys[0])
      if (target && target.fields) {
        target.fields.map((field, idx) => {
          field.display = field.display || ''
          field.required = map[field.required] || false
          if ([true, false].includes(field.notAllowEdit)) return
          field.notAllowEdit = !!field.name
          this.$set(field, '_id', new Date().getTime() + idx)
          return field
        })
      }
      console.log(target)
      return target
    },
    download () {
      window.open('https://hexyun.oss-cn-beijing.aliyuncs.com/resource/5dae66e3b825457b4560b75b/1d1feec450ccab5eb6d6849a2fb027ea.xlsx')
    }
  },
  watch: {
    model (n) {
      console.log(n)
      if (n && n.length) {
        this.data = this.deepClone(n)
        // this.data.map(item => {
        //   item.fields.map(items => {
        //     console.log(items)
        //     this.$set(items, 'name', items.field_name)
        //   })
        // })
        if (this.data[0]) {
          this.selectedKeys = [this.data[0]._id]
        }
      } else {
        this.data = []
      }
      this.spin = false
    }
  },
  mounted () {
    document.addEventListener('fullscreenchange', () => {
      if (document.fullscreenElement !== null) {
        this.enterFullData()
      } else {
        this.exitFullData()
      }
      this.$forceUpdate()
    })
  }
}
</script>

<style lang="less">
.modelModal{
  width: 90% !important;
  height: 80vh;
  max-height: 640px;
  padding: 0;
  top: 10vh;
  .ant-modal-content{
    height: 100%;
    .ant-modal-body{
      display: flex;
      padding: 0;
      height: calc(100% - 108px);
      .left{
        width: 200px;
        flex-shrink: 0;
        display: flex;
        flex-direction: column;
        .search{
          padding: 12px 8px;
          flex-shrink: 0;
          border-right: 5px solid rgba(50, 50, 50, 0.1);
        }
        .add{
          padding: 0 8px;
          font-size: 12px;
          flex-shrink: 0;
          border-right: 5px solid rgba(50, 50, 50, 0.1);
          cursor: pointer;
          i{
            color: #575757;
          }
        }
        .menu{
          padding-top: 12px;
          flex-grow: 1;
          overflow-x: hidden;
          overflow-y: scroll;
          width: 100%;
          &::-webkit-scrollbar-track{
            border-radius: 0;
          }
          .item{
            display: flex;
            margin: 0;
            padding-left: 20px;
            border-left: 4px solid rgba(0,0,0,0);
            .name{
              flex-grow: 1;
            }
            .icon{
              flex-shrink: 0;
              margin: auto;
              display: none;
            }
            &:hover{
              & .icon{
                display: block;
              }
            }
          }
          .ant-menu-item-selected{
            border-left: 4px solid #FC8830;
          }
        }
      }
      .right{
        flex-grow: 1;
        padding: 12px 24px;
        display: flex;
        width: 1px;
        flex-direction: column;
        .rightHead{
          display: flex;
          .names{
            width: 80%;
            .name{
              width: 100%;
              line-height: 20px;
              font-weight: bold;
              flex-shrink: 0;
              span{
                word-break: break-all;
              }
              i{
                font-size: 10px;
                margin-left: 8px;
                display: none;
                cursor: pointer;
              }
              &:hover{
                & i{
                  display: inline;
                }
              }
              input{
                border: none;
                outline: none;
                padding: 0;
              }
            }
          }
        }
        .fields{
          margin-top: 8px;
          text-align: center;
          line-height: 40px;
          flex-grow: 1;
          height: 1px;
          overflow: auto;
          .table{
            height: 100%;
            display: flex;
            flex-direction: column;
            .tds{
              overflow: auto;
              height: 1px;
              flex-grow: 1;
            }
            .tr{
              display: flex;
              border-bottom: 1px solid #F5F5F5;
              flex-shrink: 0;
              .th{
                flex-grow: 1;
                width: 16.6%;
                font-weight: bold;
                background: #FAFAFA;
              }
              .td{
                flex-grow: 1;
                width: 16.6%;
                flex-grow: 1;
                input{
                  outline: none;
                  border: none;
                  text-align: center;
                  width: 100%;
                  display: block;
                }
                .select{
                  width: 96%;
                  &::selection{
                    background: none;
                  }
                  .ant-select-selection{
                    border: none;
                  }
                }
              }
              .del{
                color: #F5222D;
                cursor: pointer;
              }
            }
            .puls{
              height: 40px;
              cursor: pointer;
              i{
                margin: auto;
                color: #515151;
                font-size: 16px;
                font-weight: bold;
              }
            }
          }
        }
        .empty{
          margin: auto;
        }
      }
      .spin{
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        background: rgba(247, 247, 247, 0.8);
        z-index:1;
      }
    }
    .ant-modal-footer{
      .footer{
        display: flex;
        justify-content: space-between;
        .import{
          position: relative;
          input{
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            opacity: 0;
          }
        }
      }
    }
  }
}
.ant-spin{
  position: absolute;
  left: 0;
  right: 0;
}
  .table input{
    outline: none;
    border: none;
    max-width: 80px;
    border:1px solid #eee;
  }
  .table .select {
    width: 100%;
  }
</style>
